import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { purgeAuth } from "../../Store/Reducer/authReducer";
import { useNavigate } from "react-router-dom";

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(purgeAuth());
        navigate('/login');
    }, [])

    return (<>
    </>)
}

export default Logout;